import { brandPrimary, white } from '../../styles/colors';

export const DEFAULT_COLORS = {
	background: brandPrimary,
	text: white,
	star: '#FFD700', // TODO: Add to colors.ts
} as const;

export const DEFAULT_POST_DESCRIPTIONS = [
	'Hear directly from our customers — their experience speaks volumes.',
	'Proud to share this recent feedback from one of our valued clients.',
	"Customer satisfaction is at the heart of what we do. Here's what people are saying.",
	"We're grateful for the trust our clients place in us. Here's one of their stories.",
	'Real results. Real feedback. See what our customers have to say.',
	"We strive for excellence — and it's always rewarding to hear when we've delivered.",
	'A recent review that reminds us why we do what we do.',
	'Client feedback like this drives our team to keep raising the bar.',
] as const;

export const MIN_FONT_SIZE = 12;
export const MAX_FONT_SIZE = 72;

export const LAYOUT_PREVIEW_SAMPLE = {
	reviewText:
		'From the first call they listened, explained every option in plain language, and followed through exactly when they said they would. I have already recommended them to two friends.',
	authorName: 'Jordan Reese',
	rating: 5,
} as const;
